import { trackViewItem, trackBeginCheckout, trackPurchase } from "./services/analytics/ga4Ecommerce.js";
import { captureAndStoreUtms, readUtms, injectUtmHiddenInputs } from "./services/analytics/utmCapture.js";

captureAndStoreUtms();

const api = {
    trackViewItem,
    trackBeginCheckout,
    trackPurchase,
    captureAndStoreUtms,
    readUtms,
    injectUtmHiddenInputs,
};

if (typeof window !== "undefined") {
    window.tripcartAnalytics = api;
}

export { trackViewItem, trackBeginCheckout, trackPurchase, captureAndStoreUtms, readUtms, injectUtmHiddenInputs };
export default api;
